// Behaviour that only applies inside the Capacitor app (iOS / Android).
import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
export const API_ORIGIN = 'https://dubuck.com';

// The guest token is kept apart from `token` so a later real login can take over the guest's progress
export const isGuest = () => {
  const token = localStorage.getItem('token');
  return !!token && token === localStorage.getItem('guest_token');
};

// "Try without signing up": reuse this device's guest account if there is one
export async function startGuest() {
  let token = localStorage.getItem('guest_token');
  if (!token) {
    ({ data: { token } } = await axios.post('/api/auth/guest'));
    localStorage.setItem('guest_token', token);
  }
  localStorage.setItem('token', token);
  localStorage.setItem('user_email', '');
}

// Store a real login; if this device was used as a guest, fold that progress into the account first
export async function saveLogin(token, email) {
  localStorage.setItem('token', token);
  localStorage.setItem('user_email', email);
  const guestToken = localStorage.getItem('guest_token');
  if (!guestToken || guestToken === token) return;
  // On failure the guest token stays, so the next login retries
  await axios.post('/api/auth/merge-guest', { guestToken })
    .then(() => localStorage.removeItem('guest_token'))
    .catch(() => { });
}

// Finish a social login: trade the one-time code for our JWT and go to the main screen
export async function finishLogin(code) {
  const { data } = await axios.post('/api/auth/exchange', { code });
  await saveLogin(data.token, data.user.email);
  window.location.replace('/Main');
}

// Kakao/Google login run on the server (OAuth redirect); the app opens them in the system browser
const startSocialLogin = (provider) => {
  if (isNative) Browser.open({ url: `${API_ORIGIN}/api/auth/${provider}/start?app=1` });
  else window.location.href = `/api/auth/${provider}/start`;
};
export const startKakaoLogin = () => startSocialLogin('kakao');
export const startGoogleLogin = () => startSocialLogin('google');

export default function setupNative() {
  if (!isNative) return;
  // The app's pages are bundled, so API calls must go to the real server
  axios.defaults.baseURL = API_ORIGIN;

  App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) window.history.back();
    else App.exitApp();
  });

  // com.dubuck.app://login?code=... comes back from the Kakao/Google login in the browser
  App.addListener('appUrlOpen', ({ url }) => {
    if (!url.startsWith('com.dubuck.app://login')) return;
    Browser.close().catch(() => {});
    const q = new URL(url.replace('com.dubuck.app://', 'https://app/')).searchParams;
    if (q.get('code')) finishLogin(q.get('code')).catch(() => alert('로그인 시간이 지났어요. 다시 시도해 주세요.'));
    else if (q.get('error') !== 'cancelled') alert('로그인에 실패했습니다. 다시 시도해 주세요.');
  });
}
